document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-store-locator]');
  if (!el) return;

  const apiKey = el.dataset.mapsApiKey;
  const mapContainer = el.querySelector('[data-store-map]');
  const popup = el.querySelector('[data-map-popup]');
  const popupContent = el.querySelector('[data-popup-content]');
  const popupClose = el.querySelector('[data-popup-close]');
  const toggleBtns = [...el.querySelectorAll('[data-toggle-btn]')];
  const searchInput = el.querySelector('[data-search-input]');
  const resultsCount = el.querySelector('[data-results-count]');
  const allCards = [...el.querySelectorAll('[data-store-card]')];

  let map = null;
  let markers = [];
  let activeType = toggleBtns.find((b) => b.classList.contains('store-locator__toggle-btn--active'))?.dataset.type ?? 'Salon';

  const filterCards = (query) => {
    const q = query.toLowerCase().trim();
    let visibleCount = 0;

    allCards.forEach((card) => {
      const matchesType = card.dataset.storeType === activeType;
      const cardName = card.querySelector('.store-locator-card__name')?.textContent?.toLowerCase() ?? '';
      const cardAddress = card.querySelector('.store-locator-card__address')?.textContent?.toLowerCase() ?? '';
      const matchesQuery = q === '' || cardName.includes(q) || cardAddress.includes(q);

      if (matchesType && matchesQuery) {
        card.classList.remove('is-hidden');
        visibleCount++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    if (resultsCount) {
      resultsCount.textContent = `Showing Beardo ${activeType}s (${visibleCount} results)`;
    }
  };

  const clearActiveCards = () => {
    allCards.forEach((c) => c.classList.remove('store-locator-card--active'));
  };

  const activateCard = (index) => {
    clearActiveCards();
    const target = allCards.find((c) => c.dataset.storeIndex === String(index));
    target?.classList.add('store-locator-card--active');
  };

  const closePopup = () => {
    popup?.classList.add('is-hidden');
    popupContent?.replaceChildren();
    clearActiveCards();
  };

  const openPopup = (sourceCard) => {
    if (!popup || !popupContent) return;
    popupContent.replaceChildren();
    const clone = sourceCard.cloneNode(true);
    clone.classList.remove('is-hidden', 'store-locator-card--active');
    popupContent.appendChild(clone);
    popup.classList.remove('is-hidden');
  };

  const updateMapPins = () => {
    if (!map) return;

    markers.forEach((m) => m.setMap(null));
    markers = [];

    allCards.forEach((card) => {
      if (card.dataset.storeType !== activeType) return;

      const lat = parseFloat(card.dataset.lat);
      const lng = parseFloat(card.dataset.lng);
      if (isNaN(lat) || isNaN(lng)) return;

      const storeIndex = card.dataset.storeIndex;
      const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#E31E24',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
        },
      });

      marker.storeIndex = storeIndex;
      marker.addListener('click', () => {
        activateCard(storeIndex);
        openPopup(card);
        map.panTo(marker.getPosition());
      });

      markers.push(marker);
    });
  };

  const initMap = () => {
    if (!mapContainer || typeof google === 'undefined') return;

    map = new google.maps.Map(mapContainer, {
      zoom: 5,
      center: { lat: 20.5937, lng: 78.9629 },
      zoomControl: true,
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    updateMapPins();
  };

  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      activeType = btn.dataset.type;
      toggleBtns.forEach((b) => b.classList.remove('store-locator__toggle-btn--active'));
      btn.classList.add('store-locator__toggle-btn--active');
      closePopup();
      if (searchInput) searchInput.value = '';
      filterCards('');
      updateMapPins();
    });
  });

  searchInput?.addEventListener('input', () => {
    filterCards(searchInput.value);
  });

  allCards.forEach((card) => {
    card.addEventListener('click', () => {
      const index = card.dataset.storeIndex;
      activateCard(index);
      openPopup(card);
      const marker = markers.find((m) => m.storeIndex === index);
      if (marker && map) map.panTo(marker.getPosition());
    });
  });

  popupClose?.addEventListener('click', closePopup);

  window.__storeLocatorMapInit = initMap;

  if (apiKey) {
    const mapsScript = document.createElement('script');
    mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=__storeLocatorMapInit&loading=async`;
    mapsScript.async = true;
    mapsScript.defer = true;
    document.head.appendChild(mapsScript);
  }

  filterCards('');
});
